var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isShow)?_c('waterMark',{attrs:{"overlapStyle":"height: 100%;","text":_vm.waterMarktext}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }